import { Component } from '@angular/core';
import { environment } from '../environments/environment';

/**
 * Application shell. Hosts the global header and footer around the routed
 * content, so every screen shares the same Hudson Crop & Livestock chrome.
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  /**
   * Environment badge text shown in the header. Driven by the active Angular
   * environment; blank in production so no badge renders.
   */
  protected readonly environmentLabel =
    environment.production ? '' : (environment.environmentName ?? '').toUpperCase();

  onSearch(): void {
    // TODO: open global search once it exists.
  }
}
